module.exports = __webpack_public_path__ + "static/gallery_wild_4-877719425852a208fd0b3186c70d30b3.jpg";